import BaseModel from '../BaseModel';

export default class Logo extends BaseModel {
  static entity = 'logos';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      file: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async store(companyId, payload) {
        const result = await this.post(`companies/${companyId}/logo`, payload);
        result.response.data.data.companyId = companyId;
        result.save();
        return result;
      },
      destroy(id) {
        return this.delete(`companies/logo/${id}`, { delete: id });
      },
    },
  }
}
